import m from "./index797.js";
import i from "./index798.js";
function b(d, f, n) {
  return n === void 0 && (n = f, f = void 0), n !== void 0 && (n = i(n), n = n === n ? n : 0), f !== void 0 && (f = i(f), f = f === f ? f : 0), m(i(d), f, n);
}
export {
  b as default
};
